<template>
  <div>
      <div v-html="content" @click="loadImg()" class="content" >
      </div>
      <div slot="footer" class="dialog-footer" style="text-align:center; margin:87px;">
        <el-button @click="cancelCoupon()">取消
        </el-button>
        <el-button type="primary" @click="goToRegisterPage()">立即注册
        </el-button>
      </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "couponinfo",
  components: {},
  data() {
    return {
      content: "",
      linkList: [],
      linkList1: []
    };
  },
  methods: {

    loadImg(){
    },
    cancelCoupon() {
      this.$router.push('/home');
    },
    goToRegisterPage() {
      localStorage.setItem('rePhone', this.$route.query.code);
      // window.localStorage.setItem("rePhone", this.$route.query.code);
      this.$router.push('/login/register?code='+this.$route.query.code);
    },
    getActivityDetail() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "new_user_coupon",
            coupon_id: that.$route.query.code
          }
        })
        .then(ret => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.content = resData.data;
            if(!that.content) {
              this.$router.push('/login/register?code='+this.$route.query.code);
            }
            // that.content = that.content.replace("http://wonder.apps/recharge", "#/myaccount/capital");
            // that.content = that.content.replace("http://wonder.apps/withdraw", "#/myaccount/capital");
            // that.content = that.content.replace("http://wonder.apps/realname_auth", "#/myaccount/information");
            // that.content = that.content.replace("http://wonder.apps/trading", "#/operate/operateday");
            // that.content = that.content.replace("http://wonder.apps/register", "#/login/register");
            // that.content = that.content.replace("http://wonder.apps/login", "#/login");
          } else {
            that.$alert("请稍后尝试", "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    }
  },

  // },
  mounted: function() {
    let that = this;
    if(this.$route.query.code.length == 9) {
      this.$router.push('/couponinfo?code='+this.$route.query.code);
    } else {
            // text = window.location.origin+"#/login/register?code="+coded;
      // text = window.location.origin+"#/couponinfo/?code="+this.$route.query.code;
      this.$router.push('/login/register?code='+this.$route.query.code);
    }
    this.getActivityDetail();
  }
};

// $(document).ready(function() {
//     $("a").click(function() {
//         //Do stuff when clicked
//     });
// });
</script>

<style scoped>
.content {
  margin: 0 auto;
  text-align: center;
}
.content >>> img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/couponinfo.vue